/* eslint-disable */
import React from "react";
import Modal from '../../component/Inc/Modal';
function PopMentorReport(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="pop_mentor_report" popSize="s">
      <h2 className='pop_tit'>멘토 보고서</h2>
      <div className="content_container scroll">
        <div className="com_info">
          <p className="name">김교사104</p>
          <span className="dot" />
          <p className="date">2023.05.20 11:30</p>
        </div>
        <div className="com_board_box">
          <div className="board_item">
            <div className="info">
              <span className="tit">학생명</span>
              <span className="cont"><button className="name btn_link">홍길동103 </button> (고3ㆍ경기고등학교ㆍ본사)</span>
            </div>
            <div className="info">
              <span className="tit">연락처</span>
              <div className="cont">
                <p className="txt">010-1234-233</p>
                <p className="txt"> <span>부)010-1234-233</span><span className="dot" /><span>모)010-1234-233</span></p>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">첫 수업일시</span>
              <span className="cont">2023.05.10 12:30</span>
            </div>
            <div className="info">
              <span className="tit">교사 / 담임</span>
              <span className="cont">
                <button className="btn_link">김교사302</button> / 
                <button className="btn_link">김담임302</button>
              </span>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">수업 방법</span>
              <span className="cont">대면</span>
            </div>
            <div className="info">
              <span className="tit">수업 과목</span>
              <span className="cont">과탐</span>
            </div>
            <div className="info">
              <span className="tit">기수 / 타임</span>
              <span className="cont">2기 / 2T</span>
            </div>
          </div>
          <div className="board_item memo">
            <div className="editor">
              내용입력(에디터)
            </div>
            [입회원서 분석]<br />

            [사전 상담 준비]<br />

            [CS등 기타 사항]<br />

            [회사 교재 준비]<br />

            [종합 평가]<br />
          </div>
        </div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopMentorReport;